import { cn } from "@ui/lib/utils";
import { forwardRef } from "react";

interface VideoPlayerProps {
  className?: string;
  loop?: boolean;
  onPause?: () => void;
  onPlay?: () => void;
  onSeeked?: () => void;
  onTimeUpdate?: () => void;
  src?: null | string;
}

export const VideoPlayer = forwardRef<HTMLVideoElement, VideoPlayerProps>(
  ({ className, src, onSeeked, onTimeUpdate, onPlay, onPause, loop = true }, ref) => {
    if (!src) return null;

    return (
      <video
        className={cn("h-full w-full object-contain", className)}
        loop={loop}
        muted
        onPause={onPause}
        onPlay={onPlay}
        onSeeked={onSeeked}
        onTimeUpdate={onTimeUpdate}
        ref={ref}
        src={src}
      />
    );
  },
);

VideoPlayer.displayName = "VideoPlayer";
